import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalService } from '../services/global.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {
    constructor(public router: Router, private globalService: GlobalService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.globalService.isLoggedIn()) {
            return true;
        } else {
            this.router.navigateByUrl('login');
            return false;
        }
    }
}
